import React, { useEffect, useState, createContext } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import useFetch from 'utils/hooks/useFetch';
import { ApiCheckAuth } from 'utils/constants/api';
import { ApiResponseStatusUnauthorized } from 'utils/Constant';

export const LocationContext = createContext();

export default function MainContainer({ children }) {
	const { fetch: checkAuth } = useFetch(ApiCheckAuth)
	
	let pathName = window.location.pathname
	let pathArray = pathName.split("/")
	const [locationId, setLocationId] = useState(() => {
		return localStorage.getItem("LocationId") || "";
	});

	const [isSidebarOpen, setIsSidebarOpen] = useState(localStorage.getItem("SidebarState") === "open" ? true : false);
	
	useEffect(() => {
		if (pathArray[1] !== "login"){
			fCheckAuth()
		}		
	}, [])
	useEffect(() => {
		localStorage.setItem("LocationId", locationId);
	}, [locationId]);

	if (pathArray[1] === "login"){
		return(
			<div className="overflow-hidden">
				<div className="">{ children }</div>
			</div>
		)
	}

	// Function Call API
	async function fCheckAuth(){
		if (localStorage.getItem("Token") === null){
			window.location.href = "/login"
		}else{
			await checkAuth({
				data: {}
			}).then((response) => {
				if(response.status === ApiResponseStatusUnauthorized){
					window.location.href = "/login"
				}
			})
		}
		
	}

	function fToggleSidebar(state){
		if (state){
			localStorage.setItem("SidebarState", "close")
		}else{
			localStorage.setItem("SidebarState", "open")
		}

		setIsSidebarOpen(!state)
	}

	function fOnMobileToggleSidebar(){
		if (window.innerWidth < 720) {
			fToggleSidebar(isSidebarOpen)
		}
	}

	return (
		<LocationContext.Provider value={{ locationId, setLocationId }}>
			<div className="fixed overflow-hidden h-screen w-full flex flex-col bg-black">
				<div className="sticky top-0 left-0 bottom-0 z-30 shadow-md">
					<Navbar toggleSidebar={() => { fToggleSidebar(isSidebarOpen) }} />
				</div>
				<div className='w-full h-screen overflow-hidden flex bg-white shadow-md'>
					<div className='sticky top-0 z-30 '>
						<Sidebar isOpen={isSidebarOpen} onSidebarClick={() => { fOnMobileToggleSidebar() }} />
					</div>
					<div className='p-4 sm:p-6 w-full overflow-auto bg-white sm:bg-slate-50 mb-14 sm:mb-0'>
						{ children }
					</div>
				</div>
			</div>
		</LocationContext.Provider>
	)
}
